/**
 * React Context for sharing ChartStore across components.
 * Provides centralized access to the store without prop drilling.
 */

import { createContext, useContext } from "react";

import type { ChartStore } from "~types/types";

/**
 * Context holding the ChartStore instance.
 * The store ref is stable (never changes after creation).
 */
export const ChartContext = createContext<ChartStore | null>(null);

/**
 * Hook to access the ChartStore from context.
 * Throws error if used outside ChartProvider.
 */
export function useChartContext(): ChartStore {
  const store = useContext(ChartContext);

  if (!store) {
    throw new Error("useChartContext must be used within a ChartProvider");
  }

  return store;
}
